import $api from 'http'

//API для получения алертов
export async function getAlertData(id, data) {
  return $api.get(`/employees/alert/`, data)
}

export async function getNewsData(data) {
  return $api.get(`/news/`, data)
}
export async function deleteNews(id) {
  return $api.delete(`/news/${id}/`);
}
export async function PostNews(formdata) {
  return $api.post(`/news/`, formdata ,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }); 
}
export async function createRaport(addressee, type, type_doc, text, file) {
  return $api.post('/conversion/raportsforpost/', {
    addressee,
    type,
    type_doc,
    text,
    file,
  })
}

export async function getNewsId(id,data) {
  return $api.get(`/news/${id}/`,data);
}